/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { RunErrorSchema } from './runErrorSchema';
import type { RunProgressSchema } from './runProgressSchema';
import type { SearchRunSchemaExternalPhase } from './searchRunSchemaExternalPhase';

/**
 * Client-facing view of one ``SearchRun``.
 *
 * Only the *external* phase is exposed; the internal pipeline phase
 * (queued/harvesting/reranking/...) never leaves the backend.
 *
 * ``eval_failed_count`` is the number of evaluated profiles whose criteria
 * evaluation failed after retries (their cells are ``failed``, the card is
 * unscored). A coarse count only, never which profiles: it says nothing a
 * client could not infer from the un-scored cards it is already allowed to
 * see. Live while evaluating; final once the run is ``ready`` ("N
 * candidates could not be evaluated").
 */
export interface SearchRunSchema {
  id: string;
  external_phase: SearchRunSchemaExternalPhase;
  progress?: RunProgressSchema | null;
  degraded_reasons?: string[];
  error?: RunErrorSchema | null;
  total_count?: number;
  eval_failed_count?: number;
  started_at?: string | null;
  finished_at?: string | null;
}
